export default __webpack_public_path__ + "static/media/intern_fear_3.7d235749.png";